import {
  FETCH_PURITY_CONFIGURATION_REQUEST,
  FETCH_PURITY_CONFIGURATION_SUCCESS,
  FETCH_PURITY_CONFIGURATION_FAILURE,
  ADD_PURITY_CONFIGURATION_REQUEST,
  ADD_PURITY_CONFIGURATION_SUCCESS,
  ADD_PURITY_CONFIGURATION_FAILURE,
  UPDATE_PURITY_CONFIGURATION_REQUEST,
  UPDATE_PURITY_CONFIGURATION_SUCCESS,
  UPDATE_PURITY_CONFIGURATION_FAILURE,
  DELETE_PURITY_CONFIGURATION_REQUEST,
  DELETE_PURITY_CONFIGURATION_SUCCESS,
  DELETE_PURITY_CONFIGURATION_FAILURE,
  PURITY_CONFIGURATION_FORM_ERROR,
  PURITY_CONFIGURATION_FORM_SUCCESS,
  SET_PURITY_CONFIGURATION_EDIT,
  CLEAR_PURITY_CONFIGURATION_EDIT,
} from '../../../../types/masters/metalPurity/purityConfiguration/purityConfigurationTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingPurityConfiguration: null,
};

const purityConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PURITY_CONFIGURATION_REQUEST:
    case ADD_PURITY_CONFIGURATION_REQUEST:
    case UPDATE_PURITY_CONFIGURATION_REQUEST:
    case DELETE_PURITY_CONFIGURATION_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PURITY_CONFIGURATION_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_PURITY_CONFIGURATION_SUCCESS:
    case UPDATE_PURITY_CONFIGURATION_SUCCESS:
    case DELETE_PURITY_CONFIGURATION_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_PURITY_CONFIGURATION_FAILURE:
    case ADD_PURITY_CONFIGURATION_FAILURE:
    case UPDATE_PURITY_CONFIGURATION_FAILURE:
    case DELETE_PURITY_CONFIGURATION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case PURITY_CONFIGURATION_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case PURITY_CONFIGURATION_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_PURITY_CONFIGURATION_EDIT:
      return { ...state, editingPurityConfiguration: action.payload };
    case CLEAR_PURITY_CONFIGURATION_EDIT:
      return { ...state, editingPurityConfiguration: null };
    default:
      return state;
  }
};

export default purityConfigurationReducer; 